















import { Vue, Component, Prop, Ref } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { FormDef, FormOptions, TextDef, TextOptions } from '../../type'
import FieldMixins from './FieldMixins'

@Component
export default class TextControl extends mixins(FieldMixins) {
  get options () {
    return Object.assign(new TextOptions(), this.def?.options)
  }

  get props () {
    return {
      disabled: this.disabled,
      placeholder: this.options?.placeholder || `请输入${this.def?.label}`,
      clearable: this.options?.clearable,
      maxlength: this.options?.maxlength,
      type: this.options?.dataType,
      ...(this.options?.attrs || {})
    }
  }

  onChange (val: any) {
    const fn = this.options?.onChange
    if (fn) fn({ value: this.value, form: this.actualForm, rowForm: this.rowForm })
  }
}
